

import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect } from "react"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { MdOutlineContentCopy, MdCheck } from "react-icons/md";
import { getLocationTrackingShareLink, sendShipmenLiveLocationShareLinkWithMail, sendShipmenLiveLocationShareLinkWithSms } from "../../../features/topPagesMap/topPagesMapSlice"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import { useState } from "react"
import InputMail from "../../shared/input/new/InputMail"
import Btn from "../../shared/button/Btn"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"
import { BsCheckLg } from "react-icons/bs";
const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: auto;
        max-height: 750px;
        overflow: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        padding: 30px 70px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;


        .content{
            width: 100%;
            border-radius: 10px;
            margin-top: 20px;
            display: flex;
            flex-direction: column;

            h3{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                margin-bottom: 10px;
            }

            .copy-container{
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 40px;

                .link-container{
                    padding: 5px 20px;
                    border-radius: 10px;
                    background-color: ${({theme}) => theme.secondaryBgColor};
                    width: 100%;
                    cursor: pointer;

                    .link-text{
                        color: ${({theme}) => theme.mainTextColor};
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        height: 30px;

                        .check-icon{
                            font-size: 1.4rem;
                            color: var(--color-green);
                        }

                        .copy-icon{
                            font-size: 1rem;
                            color: ${({theme}) => theme.mainTextColor};
                        }
                    }
                }

            }

            .share-container{
                display: flex;
                justify-content: space-between;
                gap: 60px;

                .share-item{
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }
            }
        }

        .btn-container{
            width: 100%;
            border-top: 1px solid ${({theme}) => theme.mainBorderColor};
            margin-top: 30px;
            padding-top: 20px;
            display: flex;
            justify-content: center;
        }

    }
`

const ShareLocationTrackingModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const {
        shareLinkShipmentId,
        isLoadingGetLocationTrackingShareLink,
        locationTrackingShareLink,
        isLoadingSendShipmenLiveLocationShareLinkWithMail,
        isLoadingSendShipmenLiveLocationShareLinkWithSms
    } = useSelector(state => state.topPagesMap)

    const [isCopied, setIsCopied] = useState(false)

    const { lockScroll, unlockScroll } = useScrollLock();

    const [mail, setMail] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")


    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


    useEffect(() => {
        if(shareLinkShipmentId){
            dispatch(getLocationTrackingShareLink(shareLinkShipmentId))
        }

    },[shareLinkShipmentId])

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
        setIsCopied(true)
    }

    useEffect(() => {
        if(isCopied){
            setInterval(() => {
                setIsCopied(false)
            },7000)
        }
    },[isCopied])

    const sendShareLink = ({type}) => {

        if(locationTrackingShareLink){
            if(type === "mail"){
                dispatch(sendShipmenLiveLocationShareLinkWithMail({
                    liveLocationLink: `https://portal.kamyoon.com.tr/sefer-takip/${locationTrackingShareLink}`,
                    email: mail 
                }))
            }
            else{
                dispatch(sendShipmenLiveLocationShareLinkWithSms({
                    liveLocationLink: `https://portal.kamyoon.com.tr/sefer-takip/${locationTrackingShareLink}`,
                    phoneNumber: phoneNumber?.slice(2) 
                }))
            }
        }
    } 


    return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <div className="content">
                <h3>Paylaşım Linki:</h3>
                <div className="copy-container">
                    <div className="link-container" onClick={() => locationTrackingShareLink && copyToClipboard(`portal.kamyoon.com.tr/sefer-takip/${locationTrackingShareLink}`)}>
                        <span className="link-text">{!isLoadingGetLocationTrackingShareLink && (isCopied ? <BsCheckLg className="check-icon"/> : <MdOutlineContentCopy className="copy-icon"/>)} {isLoadingGetLocationTrackingShareLink ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : `portal.kamyoon.com.tr/sefer-takip/${locationTrackingShareLink}`}</span>
                    </div>
                </div>

                <div className="share-container">
                    <div className="share-item">
                        <InputMail data={mail} setData={(e) => setMail(e.target.value)} name={"mail"} labelText="Mail Adresi" inputWidth={"340px"} />
                        <Btn bgColor="var(--color-main)" color="#fff" handleClick={() => sendShareLink({type: "mail"})} width={"340px"}>{isLoadingSendShipmenLiveLocationShareLinkWithMail ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Mail ile Gönder"}</Btn>
                    </div>
                    <div className="share-item">
                        <InputPhoneFormat inputWidth={"340px"} data={phoneNumber} setData={setPhoneNumber} labelText="Telefon Numarası" name={"phoneNumber"} />
                        <Btn bgColor="var(--color-main)" color="#fff" handleClick={() => sendShareLink({type: "phoneNumber"})} width={"340px"}>{isLoadingSendShipmenLiveLocationShareLinkWithSms ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "SMS ile Gönder"}</Btn>
                    </div>
                </div>

                <div className="btn-container">
                    <Btn bgColor="#fff" borderColor="var(--color-main)" color="var(--color-main)" handleClick={() => dispatch(showModal(null))} width={"300px"}>Geri</Btn>
                </div>

            </div>
           
        </div>
    </ModalContainer>
  )
}

export default ShareLocationTrackingModal